import React, { useState, useEffect, useContext } from 'react';
import withAppContext from 'tbk-components/src/hooks/withAppContext';
import Loading from 'tbk-components/src/components/Loading';
import Table, { ITablesProps } from '../../common/Tables';
import { IBaseElementProps } from 'tbk-components/src/components/BasicElement';

export interface IEventTableProps extends IBaseElementProps {
	/**
	 * Which events to show (upcoming = events after today, archived = past events, all = all events). Default = upcoming.
	 */
	eventType?: 'upcoming' | 'archived' | 'all';
	/**
	 * Number of events to show (0 for no limit). Defaults to 20.
	 */
	limit?: number;
	/**
	 * Event data
	 * @noUI
	 */
	defaultTableData?: ITablesProps;
}

/**
 * Automatic Event Table
 * @block
 * @icon calendar-alt
 */
export const EventTable: React.FC<IEventTableProps> = withAppContext(
	({
		eventType,
		limit,
		defaultTableData,
		id,
		className,
		classNames = [],
		context,
	}) => {
		const { Api } = useContext(context);
		const [tableData, setTableData] = useState<ITablesProps>(null);
		const [loading, setLoading] = useState(false);

		// Update on prop changes in editor or on initial load.
		useEffect(() => {
			if (defaultTableData) {
				setTableData(defaultTableData);
			} else {
				setLoading(true);
				Api.getEventTableData({ eventType, limit })
					.then(({ tableData }) => {
						setTableData(tableData);
					})
					.finally(() => setLoading(false) );
			}
		}, [defaultTableData, eventType, limit]);

		return loading ?
			(<Loading />) :
			(<Table {...tableData} id={id} className={className} classNames={classNames} />);
	}
);

export default EventTable;
